import GoogleLoginButton from '@components/SocialLogin/GoogleLoginButton'
import { UserContext } from '@context/UserContext'
import { createAlert, userAlerts } from '@lib/api-services/authService'
import { ACTIVEPIPE_COOKIE, setCookie } from '@lib/cookies'
import { createFavouriteFromLocalstore } from '@lib/helpers'
import { Router } from '@routes'
import LoginEmail from './LoginEmail'

import HeroSection from '@global/Blocks/Hero'
import useBodyClass from '@hooks/useBodyClass'
import { Container, Content } from '@styles/global.styled'
import * as S from './Login.styled'
import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'

const Login = (props) => {
  const { title, text, links, pageData } = props
  useBodyClass('modal-open', false)

  const loginAndRedirect = async ({ token, user }) => {
    const { setToken, setProfile, returnto, setAlerts } = props
    await setToken(token)
    await setProfile(user)

    /*
      Create alert/favourite from localstorage data if have
    */
    const saveSearchParams = localStorage.getItem('saveSearchParams')
    if (saveSearchParams) {
      const alertResponse = await createAlert(
        token,
        JSON.parse(saveSearchParams)
      )
      if (!alertResponse.error) {
        const alertResponse = await userAlerts(token)
        setAlerts(alertResponse.results)
      }
      localStorage.removeItem('saveSearchParams')
    }

    await createFavouriteFromLocalstore(token)
    if (Router.router.query.redirect) {
      Router.pushRoute(Router.router.query.redirect)
    } else if (user && user.subscriber) {
      if (returnto && returnto.path)
        Router.pushRoute(returnto.path).then(
          () => window && window.scrollTo(0, 0)
        )
      else {
        setCookie(ACTIVEPIPE_COOKIE, true, 36500) // expires in 100 years
        Router.pushRoute('/my-account')
      }
    }
  }

  return (
    <>
      <HeroSection
        title={pageData.hero_text || pageData.content_heading}
        bgImageUrl={
          pageData.header_image?.meta?.download_url ||
          '/imgs/background-login.jpg'
        }
        bgPosition={pageData.hero_image_anchor}
      />

      <Container>
        <S.FormContainer>
          <S.ContainerLeft>
            <S.Title>{pageData.content_heading || title}</S.Title>
            <Content dangerouslySetInnerHTML={{ __html: pageData.content_text || text }} />
          </S.ContainerLeft>

          <S.ContainerRight>
            <S.SocicalLogin>
              <GoogleLoginButton
                onLogin={loginAndRedirect}
                buttonText={links.google.label}
              />
            </S.SocicalLogin>
            <S.Line>
              <S.LineText>or via Email</S.LineText>
            </S.Line>
            <S.Form>
              <LoginEmail />
            </S.Form>
          </S.ContainerRight>
        </S.FormContainer>
      </Container>

      <WagtailBlocksSection blocks={pageData.content_blocks} />
    </>
  )
}

const ContextWrappedLogin = (props) => (
  <UserContext.Consumer>
    {(context) => <Login {...props} {...context} />}
  </UserContext.Consumer>
)

ContextWrappedLogin.defaultProps = {
  title: 'WELCOME',
  text: 'Your personal Barry Plant account allows you to remember your preferred office, save search results, bookmark properties, and gain access to exclusive listings.',
  links: {
    facebook: {
      label: 'login with facebook',
      link: '#',
    },
    google: {
      label: 'login with google',
      link: '#',
    },
    email: {
      label: 'login with email',
      link: '#',
    },
    register: {
      label: 'Register',
      link: '/create-account/',
    },
  },
}

export default ContextWrappedLogin
